import { ProductSearchMaterial } from '@productSearch/types';

export const isUnavailable = (
  product: ProductSearchMaterial,
  activeProductId?: string,
) => {
  let productId = activeProductId;

  if (
    (activeProductId == product.familyId || !activeProductId) &&
    !product.primaryChildId
  ) {
    productId = product.primaryChildId;
  }

  return (
    product.isUnavailable ||
    product.colorVariants?.items?.find((p) => p.entity_id == productId)
      ?.is_unavailable
  );
};
